import i18n from 'i18next';

export default ({ localeLabels, locales }) => ({
  locale: {
    type: 'Select',
    label: i18n.t('choose-locale'),
    help: i18n.t('choose-locale-help'),
    selectProps: { isFluid: true, isFullWidth: true },
    options: localeLabels.flatMap(({ key, name }) =>
      locales.every(({ locale }) => locale !== key) ? { label: name, value: key } : [],
    ),
    validators: [{ type: 'isRequired' }],
  },
});
